import React from 'react';
import { OutboundOrder } from '../../../../api/warehouse/generated/src';
// import { Order } from '../../types';

interface HeaderProps {
  order: OutboundOrder;
  onBack: () => void;
  progress: number;
  totalPickedQty: number;
  totalRequiredQty: number;
}

export const Header: React.FC<HeaderProps> = ({ 
  order, 
  onBack, 
  progress, 
  totalPickedQty, 
  totalRequiredQty 
}) => {

  const fixedProgress = Math.min(100, progress);
  return (
    <div className="bg-blue-600 text-white p-2 sticky top-0 z-10 shadow-lg">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between mb-2">
          <button
            onClick={onBack}
            className="text-white hover:text-blue-100 text-sm md:text-base"
          >
            ← Zurück
          </button>
          <h1 className="text-lg md:text-xl font-bold">{order.orderNumber}</h1>
        </div>
        <div className="w-full bg-blue-400 rounded-full h-2">
          <div 
            className="bg-white h-2 rounded-full transition-all duration-500"
            style={{ width: `${fixedProgress}%` }}
          />
        </div>
        <p className="text-sm text-blue-100 mt-1">
          {Math.round(fixedProgress)}% abgeschlossen ({totalPickedQty} von {totalRequiredQty} Stück)
        </p>
      </div>
    </div>
  );
};